/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Row_GoneInputs */



/**
* | output |
* | --- |
* | "This row no longer exists. The table has been refreshed." |
*
* @param {Datasets_Row_GoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_row_gone = /** @type {((inputs?: Datasets_Row_GoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Row_GoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Zeile existiert nicht mehr. Die Tabelle wurde aktualisiert.")
	return /** @type {LocalizedString} */ ("This row no longer exists. The table has been refreshed.")
});